import React, { useState } from 'react'
import {
  smilesImagesLargeHeight,
  smilesImagesLargeWidth,
  smilesImagesSmallHeight,
  smilesImagesSmallWidth,
  smilesImagesUrl,
} from 'config'
import SmilesDialog from './SmilesDialog'
import { Box, Divider, Popover, Table, TableBody, TableCell, TableRow } from '@mui/material'
import _ from 'lodash'
import SmilesDataViewer from './SmilesDataViewer'

type SmilesImageProps = {
  smiles: string
  smilesData?: any
  columns?: any
}
const SmilesImage: React.FC<SmilesImageProps> = ({
  smiles,
  smilesData,
  columns,
}) => {
  const [isDialogOpened, setIsDialogOpened] = useState(false)
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null)
  const imageUrl = `${smilesImagesUrl}?smiles=${encodeURIComponent(smiles)}`

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handlePopoverClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)

  return (
    <>
      <img
        alt={`${smiles}`}
        className="cursor-pointer"
        width={smilesImagesSmallWidth}
        height={smilesImagesSmallHeight}
        src={`${imageUrl}&w=${smilesImagesSmallWidth}&h=${smilesImagesSmallHeight}`}
        onClick={() => setIsDialogOpened(true)}
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
      />

      <Popover
        id="mouse-over-popover"
        sx={{
          pointerEvents: 'none',
          left: '25%',
          top: '-14%',
          height: '70%',
          width: '500px',
          padding: '5px'
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'center',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <Box sx={{ padding: '20px'}}>
          <SmilesDataViewer
            imageWidth={300}
            imageHeight={300}
            smilesImgUrl={imageUrl}
            columns={columns}
            smilesData={smilesData}
            setLoading={() => {}}
          />
        </Box>
      </Popover>

      {isDialogOpened && (
        <SmilesDialog
          columns={columns}
          smilesData={smilesData}
          smilesImgUrl={`${imageUrl}&w=${smilesImagesLargeWidth}&h=${smilesImagesLargeHeight}`}
          imageWidth={smilesImagesLargeWidth}
          imageHeight={smilesImagesLargeHeight}
          onClose={() => setIsDialogOpened(false)}
        />
      )}
    </>
  )
}

export default SmilesImage
